import icon from '@/assets/alveary/alveary-icon.png'

/** Decorative identity; the enclosing link or button supplies its accessible name. */
export function AlvearyMark({ size = 36 }: { size?: number }) {
  return (
    <img
      src={icon}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className="shrink-0 rounded-[24%] object-contain"
      draggable={false}
      data-testid="alveary-mark"
    />
  )
}
